import merge from "lodash/merge";
import { CandlestickSeriesOptions, ChartCandle} from '../chart.typings'
import BaseChartSeries from "./baseSeries";
import { DeepPartial } from 'lightweight-charts'
import { DEFAULT_SETTINGS } from '../../chartSettings/ChartSettingsDialogs'
import { ChartType } from '../../../proto/generated/chart'
import { deepClone } from '@mui/x-data-grid/utils/utils'

class highLowCandleSeries extends BaseChartSeries<ChartCandle, CandlestickSeriesOptions> {

    addSeriesToChart() {
        return this.chart.chartApi.addCandlestickSeries(this.seriesOptions)
    }

    getDefaultOptions(): CandlestickSeriesOptions {
        return merge(DEFAULT_SETTINGS[ChartType.HIGH_LOW], this.options)
    }
    onOptionsUpdate(options: DeepPartial<CandlestickSeriesOptions>): void {
            this._setData(this.rawData)
    }
    generateSeriesData(data: ChartCandle[], metadata: Record<string,any> = {}): ChartCandle[]{
        const color = this.seriesOptions.upColor || "#2862ff";
        const borderColor = this.seriesOptions.borderUpColor || "#2862ff";
        return (deepClone(data) as ChartCandle[]).map((candle,index) => {
            candle.open=candle.high;
            candle.close=candle.low;
            return{
                ...candle,
                color: color,
                borderColor: borderColor,
            }
        })

    }

}


export default highLowCandleSeries;